<template>
  <div class="table table-chart">
    <div class="chart-wrap">
      <div class="chart">
        <apexchart
          width="100%"
          height="119%"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>

    <div class="table-row" v-for="label in labels()">
      <div class="table-unit">
        <div class="table-chart-label">
          {{ label | currency({ fractionCount: 0 }) }}
        </div>
      </div>
      <div class="table-unit" v-for="s in values"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoeLineChart",
  props: {
    values: {
      type: Array
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          toolbar: { show: false },
          selection: { enabled: false },
          animations: { enabled: false },
          type: "line"
        },
        stroke: {
          width: 2,
          curve: "straight"
        },
        tooltip: {
          enabled: false
        },
        grid: {
          show: false,
          padding: {
            top: 20,
            left: 0,
            right: 0,
            bottom: 0
          }
        },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            colorStops: this.gradient()
          }
        },
        markers: {
          tooltip: {
            shared: false,
            intersect: false
          },
          discrete: [
            {
              seriesIndex: 0,
              dataPointIndex: 0,
              fillColor: "#ffffff",
              strokeColor: "#5dade2",
              size: 6
            },
            {
              seriesIndex: 0,
              dataPointIndex: 1,
              fillColor: "#ffffff",
              strokeColor: "#7caba2",
              size: 6
            },
            {
              seriesIndex: 0,
              dataPointIndex: 2,
              fillColor: "#ffffff",
              strokeColor: "#f3b95a",
              size: 6
            },
            {
              seriesIndex: 0,
              dataPointIndex: 3,
              fillColor: "#ffffff",
              strokeColor: "#667d95",
              size: 6
            }
          ],

          size: 7,
          strokeWidth: 2,
          strokeOpacity: 1,
          fillOpacity: 1,
          radius: 12,
          hover: {
            size: 7
          }
        },
        yaxis: {
          min: this.minValue(),
          max: this.maxValue(),
          tickAmount: 3
        }
      },
      series: [
        {
          data: this.seriesData()
        }
      ]
    };
  },
  methods: {
    seriesData() {
      return this.values.map((value, index) => {
        value = +value;
        index === 0 ? (value += 1) : value;
        return { x: `${index + 1}`, y: value };
      });
    },
    minValue() {
      let minValue = Math.ceil(Math.min(...this.values));
      let zeros = Math.pow(10, minValue.toString().length - 1);
      return Math.floor(minValue / zeros) * zeros;
    },
    range() {
      let maxValue = Math.ceil(Math.max(...this.values));
      let range = Math.ceil((maxValue - this.minValue()) / 3);
      let zeros = Math.pow(10, range.toString().length - 1);
      return Math.ceil(range / zeros) * zeros;
    },
    maxValue() {
      return this.minValue() + this.range() * 3;
    },
    labels() {
      return [
        this.minValue(),
        this.minValue() + this.range(),
        this.minValue() + this.range() * 2,
        this.minValue() + this.range() * 3
      ].reverse();
    },
    gradient() {
      let count = this.values.length;
      let colors = ["#5dade2", "#7caba2", "#f3b95a", "#667d95"];
      return this.values.map((v, index) => {
        let offset;
        if (index === count - 1) offset = 100;
        if (index === 0) offset = 0;
        if (index === 1 && count === 4) offset = 25;
        if (index === 2 && count === 4) offset = 75;
        if (index === 1 && count === 3) offset = 50;
        return {
          offset: offset,
          color: colors[index],
          opacity: 1
        };
      });
    }
  }
};
</script>
